import { gql } from '@apollo/client';

export const GET_PUBLIC_EMPLOYER_INFO = gql`
  query getPublicEmployerInfo($employerId: ID!) {
    epol_getPublicEmployerInfo(employerId: $employerId) {
      employerResources {
        type
        value
      }
    }
  }
`;
